import React, { useContext } from "react";
import { ApplicationsContextProvider } from "./applications";
import { EventsContextProvider } from "./events";
import { InvitationsContextProvider } from "./invitations";
import { PartnersContextProvider } from "./partners";
import { PromosContextProvider } from "./promos";

const combineComponents = (...components) => {
    return components.reduce(
        (AccumulatedComponents, CurrentComponent) => {
            return ({ children }) => {
                return (
                    <AccumulatedComponents>
                        <CurrentComponent>{children}</CurrentComponent>
                    </AccumulatedComponents>
                );
            };
        },
        ({ children }) => <>{children}</>
    )
}

const providers = [
    ApplicationsContextProvider,
    InvitationsContextProvider,
    PartnersContextProvider,
    EventsContextProvider,
    PromosContextProvider
]

export const AppContextProvider = combineComponents(...providers)
